var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT @ "+_vm._s(new Date().getFullYear())+" Vila Galé")]),_c('span',{staticClass:"md:flex hidden items-center"})])}
var staticRenderFns = []

export { render, staticRenderFns }